import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretExpandY = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("polygon", { points: "7.5 7 10 4 12.5 7 7.5 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", fill: "currentColor" }),
        React.createElement("polygon", { points: "7.5 13 10 16 12.5 13 7.5 13", fill: "currentColor", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" })));
};
//# sourceMappingURL=IconCaretExpandY.js.map